import React from 'react'
import EmailIcon from '@mui/icons-material/Email'
import FacebookIcon from '@mui/icons-material/Facebook'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import PhoneIcon from '@mui/icons-material/Phone'
import './LandingPageFooter.css'
import cnergiLogo from '../resources/CNERGI_PNG@4x.png'
import dostLogo from '../resources/dost_logo_dost.png'
import { SecondaryButton } from './Buttons'

function LandingPageFooter() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="landing-footer">
      <section className="landing-footer__funding" aria-label="DOST FASTRAC funding acknowledgment">
        <div className="landing-footer__funding-logo">
          <img src={dostLogo} alt="Department of Science and Technology" />
        </div>
        <div className="landing-footer__funding-copy">
          <span>Technology development assisted by</span>
          <strong>Department of Science and Technology</strong>
          <p>Through the DOST–FASTRAC Program.</p>
        </div>
      </section>

      <div className="landing-footer__inner">
        <div className="landing-footer__brand-group">
          <a className="landing-footer__brand" href="/" aria-label="CNERGI home">
            <img className="landing-footer__logo" src={cnergiLogo} alt="CNERGI" />
          </a>
          <p>Intelligent Energy. Visible Impact.</p>
          <div className="landing-footer__socials" aria-label="Social links">
            <a href="#linkedin" aria-label="CNERGI on LinkedIn">
              <LinkedInIcon className="landing-footer__social-icon" aria-hidden="true" />
            </a>
            <a href="#facebook" aria-label="CNERGI on Facebook">
              <FacebookIcon className="landing-footer__social-icon" aria-hidden="true" />
            </a>
          </div>
        </div>

        <div className="landing-footer__contact-grid">
          <div className="landing-footer__contact-block">
            <LocationOnIcon className="landing-footer__icon" aria-hidden="true" />
            <div>
              <h2>Address</h2>
              <address>
                1F Plaza de Corazon, Flora Avenue, Santo Rosario (Poblacion),
                Angeles City, Pampanga 2009
              </address>
            </div>
          </div>

          <div className="landing-footer__contact-block">
            <PhoneIcon className="landing-footer__icon" aria-hidden="true" />
            <div>
              <h2>Phone</h2>
              <a href="tel:+630000000000">+63 000 000 0000</a>
              <SecondaryButton className="landing-footer__button" href="tel:+630000000000">Call Us</SecondaryButton>
            </div>
          </div>

          <div className="landing-footer__contact-block">
            <EmailIcon className="landing-footer__icon" aria-hidden="true" />
            <div>
              <h2>Email</h2>
              <a href="mailto:marketing@cnergi.tech">marketing@cnergi.tech</a>
              <SecondaryButton className="landing-footer__button" href="mailto:marketing@cnergi.tech">Email Us</SecondaryButton>
            </div>
          </div>
        </div>
      </div>

      <div className="landing-footer__bottom">
        <span>&copy; {currentYear} CNERGI. All rights reserved.</span>
        <span>Smart Energy. Tangible Proof.</span>
      </div>
    </footer>
  )
}

export default LandingPageFooter
